import { useGlobalStore } from "@/stores/globalStore";

export default () => {
  const useLoadingStateAction = (isLoading) => {
    const store = useGlobalStore();
    store.setIsFormLoading(isLoading);
  };

  return {
    useLoadingStateAction,
  };
};
